import React from 'react';
import PropTypes from 'prop-types';

function Twitter({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        stroke="transparent"
        fill="currentColor"
        d="M18.816 8.064a6.201 6.201 0 01-1.68.48c.576-.384 1.056-.912 1.296-1.584-.576.336-1.2.576-1.824.72a2.864 2.864 0 00-2.112-.912c-1.584 0-2.928 1.296-2.928 2.928 0 .24.048.432.096.672-2.4-.096-4.56-1.296-6-3.024-.24.336-.384.816-.384 1.344 0 1.008.528 1.92 1.296 2.4-.48 0-.912-.144-1.296-.384v.048c0 1.392 1.008 2.592 2.352 2.832a3.73 3.73 0 01-.768.096c-.192 0-.384 0-.528-.048.384 1.152 1.44 2.016 2.736 2.016-1.008.768-2.256 1.248-3.6 1.248-.24 0-.48 0-.672-.048 1.152.912 2.688 1.392 4.32 1.392 5.328 0 8.256-4.416 8.256-8.256V9.6c.576-.432 1.056-.912 1.44-1.536z"
      />
    </svg>
  );
}

Twitter.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Twitter;
